import AdjustmentTypeTrigger from "../model/AdjustmentTypeTrigger";
import { addPresentation } from "./presentation";

export default addPresentation(AdjustmentTypeTrigger, {
  canAdd: true,
  canEdit: true,
  canRemove: false,
  columns: ["Code", "Name"],
});
